import Logo from '../../assets/images/onbeef_logo.png';
import { useSlug } from '../../hooks/useSlug';
import { useMerchantCache } from '../../queries/home';

const Footer = () => {
  const params = useSlug();
  const { isLoading } = useMerchantCache(params.slug);

  const handleOpenOnbeef = () => {
    window.open('https://onbeefapp.com.br/', '_blank');
  };

  if (isLoading) return null;

  return (
    <footer className="bg-[#f5f5f5] text-gray-600 py-1 border-t-[2px] border-gray-300 flex items-center justify-center text-center z-50 sticky shadow-md">
      <button
        className="flex flex-col md:flex-row items-center justify-center gap-2 font-light mt-4 md:mt-0"
        type="button"
        onClick={handleOpenOnbeef}
      >
        <span className="text-xs text-gray-600 whitespace-nowrap flex items-center justify-center text-center">
          © {new Date().getFullYear()} Desenvolvido por Onbeef
        </span>
        <img className="h-12 md:h-8" src={Logo} alt="Logo Onbeef" />
      </button>
    </footer>
  );
};

export default Footer;
